<script setup lang="ts">
import { ErrorState, Skeleton } from '@taler/ui'
import { useI18n } from 'vue-i18n'
import type { RouteLocationRaw } from 'vue-router'
import { TILE_CLASS } from '../internal/tile.ts'

defineProps<{
  title: string
  isLoading: boolean
  error: Error | null
  viewAll?: RouteLocationRaw
  retrying?: boolean | undefined
}>()
const emit = defineEmits<{ retry: [] }>()

const { t } = useI18n()
</script>

<template>
  <section :class="[TILE_CLASS, 'min-w-0']" :aria-label="title">
    <header class="flex items-center justify-between gap-2">
      <h2 class="text-[length:var(--text-step-4)] font-semibold text-[color:var(--color-text)]">
        {{ title }}
      </h2>
      <RouterLink
        v-if="viewAll"
        :to="viewAll"
        class="text-[length:var(--text-step-1)] text-[color:var(--color-accent)]"
      >
        {{ t('reporting.viewAll') }}
      </RouterLink>
    </header>
    <div v-if="isLoading" aria-hidden="true" class="flex flex-col gap-2">
      <Skeleton width="60%" height="1.5rem" />
      <Skeleton width="100%" height="4rem" />
    </div>
    <ErrorState
      v-else-if="error"
      :title="t('dashboard.panelErrorTitle')"
      :retry-label="t('dashboard.retry')"
      :retrying="retrying"
      @retry="emit('retry')"
    />
    <slot v-else />
  </section>
</template>
